import React from "react";
import { useRef,useContext,useEffect,useState} from 'react';
import { useNavigate } from 'react-router-dom';
import Header from "../pages/inc/Header";
import Footer from "../pages/inc/Footer";
import Userprofile from "./Trainer/User_profile";
import Trainerchangepassword from "./Trainer/Trainerchangepassword";
import { GlobalContext } from '../GlobalContext';
import { useTranslation } from 'react-i18next';


const Home = () => {
const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const userprofile = {
    "name":"John Doe",
    "description":"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed congue, nulla nec cursus lacinia, mauris nibh accumsan tellus, et ultrices quam nisl non nulla. Nunc laoreet quis lectus eu hendrerit.",
    "logo" : "img/cfn-banner-logo.svg"
  }
  


  const buttonRef = useRef(null);

  const handleClick = () => {
    if (buttonRef.current) {
      buttonRef.current.click();
    }
  };
  return (   
    <>
    <div class="loader d-none" id="loder-tive">
	<div class="loader-content">
		<div id="loader-animation"></div>
	</div>
</div>
    <Header ref={buttonRef} />
  
    <Trainerchangepassword handlelogout={handleClick} />
    <Footer/>
   
    </>
  );
};

export default Home;